import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LayoutDashboard, Server, HelpCircle } from 'lucide-react';

import Logo from './Logo';
import DesktopNav from './DesktopNav';
import UserMenu from './UserMenu';
import MobileNav from './MobileNav';

import { useSession } from '../../../../features/auth/hooks/useSession';
import { useLogout } from '../../../../features/auth/hooks/useLogout';

const navLinks = [
  { to: '/app/dashboard', label: 'Tableau de bord', icon: LayoutDashboard },
  { to: '/app/services', label: 'Services', icon: Server },
  { to: '/app/support', label: 'Support', icon: HelpCircle },
];

const Header: React.FC = () => {
  const navigate = useNavigate();

  const { user, isAuthenticated } = useSession();
  const { logout } = useLogout();

  const initials =
    user?.display_name?.[0] ||
    user?.username?.[0] ||
    'U';

  return (
    <>
      <motion.header
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.4, ease: 'easeOut' }}
        className="fixed top-0 left-0 right-0 z-40 bg-white/80 backdrop-blur-md shadow-lg border-b border-gray-200/70"
      >
        <div className="container mx-auto px-4 flex items-center justify-between h-16">
          <Logo />

          <DesktopNav links={navLinks} />

          {isAuthenticated && user ? (
            <UserMenu
              userName={user.display_name || user.username}
              initials={initials}
              isAuthenticated={true}
              onLogout={logout}
            />
          ) : (
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => navigate('/auth/login')}
              className="bg-accent text-white px-6 py-2 rounded-full text-sm font-bold shadow-md hover:shadow-lg transition-all"
            >
              Connexion
            </motion.button>
          )}
        </div>
      </motion.header>

      <MobileNav links={navLinks} />
      <div className="h-16" />
    </>
  );
};

export default Header;